import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SessionsSummary } from "./sessions-summary";
import { PaymentsSummary } from "./payments-summary";
import { ExceptionsSummary } from "./exceptions-summary";
import { BundleUsage } from "@/pages/users/types/user";
import { ExceptionLog } from "@/features/exception-logs/types/exception-log";

interface UserSummaryCardProps {
  sessionsSummary: {
    total: number;
    used: number;
  };
  sessionsRemaining: number;
  paymentSummary: Record<string, number>;
  bundlesGroupedByName: Record<string, BundleUsage[]>;
  closestToExpiry?: {
    remaining: number;
    daysUntilExpiry: number;
  } | null;
  exceptionLogs?: ExceptionLog[];
}

export function UserSummaryCard({
  sessionsSummary,
  sessionsRemaining,
  paymentSummary,
  bundlesGroupedByName,
  closestToExpiry,
  exceptionLogs = [],
}: UserSummaryCardProps) {
  return (
    <Card className="bg-white/10 border-white/20">
      <CardHeader className="pb-3">
        <CardTitle className="text-base text-white">Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-0">
        <SessionsSummary
          sessionsSummary={sessionsSummary}
          sessionsRemaining={sessionsRemaining}
          bundlesGroupedByName={bundlesGroupedByName}
          closestToExpiry={closestToExpiry}
        />
        <PaymentsSummary
          paymentSummary={paymentSummary}
          bundlesGroupedByName={bundlesGroupedByName}
        />
        <ExceptionsSummary exceptionLogs={exceptionLogs} />
      </CardContent>
    </Card>
  );
}

